import React from 'react';

const ApplicationForm = () => {
    return (
        <div>
            <h1>Application Form</h1>
        </div>
    );
};

export default ApplicationForm;